import { createModuleContext } from '@rebuild/utils/moduleContext';

function buildBaseCtx() {
	return {
		staticCoverList: {}
	};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(
	'performance_report',
	buildBaseCtx
);

export { provideCurrentContext, useCurrentContext };
